import React, { useState, useEffect, useRef } from "react";
import { Button } from "../components/ui/button";
import { useNavigate, Link } from "react-router-dom";
import axios from "../axiosInstance";
import HighPerformanceAd from "../components/HighPerformanceAd";
import AdScriptCard from "../components/AdScriptCard";
import SocialBarAd from "../components/SocialBarAd";

export default function AutoSurf() {
  const [currentAd, setCurrentAd] = useState(null);
  const currentAdRef = useRef(null); // ✅ Ref pour garder le currentAd à jour

  const [coinzEarned, setCoinzEarned] = useState(0);
  const [level, setLevel] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [toast, setToast] = useState({ message: "", type: "" });

  const navigate = useNavigate();
  const countdownInterval = useRef(null);

  const [showSocialBar, setShowSocialBar] = useState(false);
  const socialBarTimeoutRef = useRef(null);

  const showToast = (message, type = "error") => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 4000);
  };

  const getUserLevel = async () => {
    try {
      const res = await axios.get(`/api/user/me`, { withCredentials: true });
      setLevel(res.data.userLevel);
    } catch (err) {
      console.error("Error fetching user level:", err);
    }
  };

  const fetchAd = async () => {
    try {
      const res = await axios.get("/api/autosurf/ad", {
        withCredentials: true,
        timeout: 10000,
      });
      setCurrentAd(res.data);
      currentAdRef.current = res.data; // ✅ Mettre à jour la ref
    } catch (err) {
      showToast("No ads available.");
      stopAutosurf();
    }
  };

  const startAutosurf = async () => {
    setIsRunning(true);
    setCoinzEarned(0);
    await fetchAd();
    startCountdown();
  };

  const stopAutosurf = () => {
    setIsRunning(false);
    clearInterval(countdownInterval.current);
    setCurrentAd(null);
    currentAdRef.current = null;
    navigate("/autosurf");
  };

  const startCountdown = () => {
    setCountdown(30);
    clearInterval(countdownInterval.current);
    countdownInterval.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval.current);
          finishAd();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const finishAd = async () => {
    const ad = currentAdRef.current; // ✅ Toujours prendre la ref
    if (!ad) return;
    try {
      const res = await axios.post(
        "/api/autosurf/credit",
        {
          level,
          adId: ad.id,
        },
        { withCredentials: true }
      );
      setCoinzEarned((prev) => prev + res.data.reward);
    } catch (err) {
      console.error("Error crediting coinz:", err);
    }
    await fetchAd();
    startCountdown();
  };

  useEffect(() => {
    document.title = "AutoSurf Session | CoinzUp";
    getUserLevel();
    return () => clearInterval(countdownInterval.current);
    
  }, []);

  useEffect(() => {
    if (!isRunning) {
      setShowSocialBar(false);
      clearTimeout(socialBarTimeoutRef.current);
      return;
    }
  
   // Changer à 10 ici 
    const initialDelay = 1 * 60 * 1000; // 10 minutes en ms
  
    const scheduleToggle = () => {
      
      // Temps aléatoire entre 10 et 15 minutes
      const randomDelay =
        (2 + Math.random() * 2) * 60 * 1000; // en ms
  
      socialBarTimeoutRef.current = setTimeout(() => {
        setShowSocialBar((prev) => !prev);
        scheduleToggle(); // relance la prochaine apparition/disparition
      }, randomDelay);
    };
  
    // Démarrer après initialDelay
    socialBarTimeoutRef.current = setTimeout(() => {
      setShowSocialBar(true);
      scheduleToggle();
    }, initialDelay);
  
    return () => clearTimeout(socialBarTimeoutRef.current);
  }, [isRunning]);

  return (
    <>
     <AdScriptCard scriptSrc="//spendharassingwarmly.com/06/24/a0/0624a04d58c0a5ce026b8eb2c26a839e.js" />
    
       {/* Nouveau composant social bar */}
    <SocialBarAd isActive={showSocialBar} /> 

    <div className="h-full flex flex-col bg-black text-white">
      {/* Header */}

     

      <div className="bg-gray-800 p-4 shadow flex justify-between items-center">
        <div className="flex items-center gap-4">
          <Link to="/dashboard">
            <img
              src="/static/media/new_logo_without_font.d2a01c8b4f6a79d54286.png"
              alt="CoinZUp Logo"
              className="w-24"
            />
          </Link>
          <div>
            <h1 className="text-xl font-bold">AutoSurf Session</h1>
            <p className="text-xs text-gray-300">
              Each site stays open for 30 seconds. Earn{" "}
              <span className="text-green-400 font-semibold">2 COINZ</span> per
              site.
              <a
                href="/levelup"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-400 hover:text-blue-300 ml-2"
              >
                Learn more
              </a>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-sm text-gray-200">
            <p>
              Coinz earned:{" "}
              <span className="text-yellow-400 font-bold">
                {coinzEarned}
              </span>
            </p>
            {isRunning && (
              <p>
                Time left:{" "}
                <span className="text-yellow-400 font-bold">
                  {countdown}s
                </span>
              </p>
            )}
          </div>
          {!isRunning ? (
            <Button
              className="bg-green-600 hover:bg-green-700"
              onClick={startAutosurf}
            >
              Start
            </Button>
          ) : (
            <Button
              className="bg-red-600 hover:bg-red-700"
              onClick={stopAutosurf}
            >
              Stop
            </Button>
          )}
        </div>
      </div>



      {/* Iframe area */}
      <div className="flex-grow">
        {isRunning && currentAd ? (
          <iframe
            src={currentAd.url}
            title="AutoSurf Ad"
            className="w-full h-full border-none"
          ></iframe>
        ) : (
               
          <div className="flex justify-center items-center h-full text-gray-400">
            <p>Click “Start” to begin auto-surfing ads.</p>
          </div>
          
        )}
      </div>



      {toast.message && (
        <div
          className={`fixed bottom-4 right-4 px-4 py-2 rounded text-white ${
            toast.type === "error" ? "bg-red-600" : "bg-green-600"
          }`}
        >
          {toast.message}
        </div>
      )}
    </div>
    </>
  );
}
